import React from "react";
import { createPortal } from "react-dom";
import { useAuth } from "contexts/AuthProvider";
import { ConsentForm } from "./ConsentForm";
import { MYCORR_MARK } from "@/lib/mycorrMark";

const MycorrLogo = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      d={MYCORR_MARK}
      stroke="currentColor"
      strokeWidth="4"
      strokeLinejoin="bevel"
    />
  </svg>
);

/** Without `onClose` it blocks: the way out is logging out. */
export const ConsentModal = ({
  onClose,
  reason,
}: {
  onClose?: () => void;
  /// What the person just tried, from a door's `terms_not_accepted`.
  reason?: string;
}) => {
  const { tosAccepted, tosAcceptedBefore, ppAccepted, logout } = useAuth();

  if (tosAccepted && ppAccepted) {
    return null;
  }

  // Portaled at dialog height: Settings can open it over its own card.
  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/40"
      style={{ zIndex: "var(--z-dialog)" }}
    >
      <div
        className="relative bg-bg border border-border rounded-app shadow-lg w-full max-w-120 mx-4 max-h-[90vh] flex flex-col overflow-y-auto overscroll-none"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 flex flex-col gap-6 min-h-0">
          <div className="flex flex-col items-center gap-3 text-center">
            <MycorrLogo />
            <h2 className="text-lg font-semibold text-fg">
              {tosAcceptedBefore ? "Updated Terms" : "Welcome to Mycorr"}
            </h2>
            <p className="text-xs text-fg-muted leading-relaxed">
              {reason ||
                (tosAcceptedBefore
                  ? "We've updated our terms. Please review to continue."
                  : "Review and accept our terms to get started.")}
            </p>
          </div>

          <ConsentForm onAccepted={() => {}} compact />

          <div className="text-center">
            <button
              onClick={onClose ?? logout}
              className="text-xs text-fg-muted hover:text-fg cursor-pointer bg-transparent border-none"
            >
              {onClose ? "Not now" : "Log out"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};
